module.exports = __webpack_public_path__ + "media/images/logo-4-30ce2fcacc49151fb2eb29874897294f.png";